import React from 'react';

import { Box } from '@opendoor/bricks/core';
import { MarginProps } from '@opendoor/bricks/system/theme';
import { InternalLink } from 'platform/react-router';

import { getHubORVAScheduleRoute } from 'shared/helpers/routes';
import { useOfferContext } from 'sellDirect/OfferContext';
import { OdProtosWebData_ORVAState as ORVAState } from '__generated__/globalTypes';

interface ScheduleOrvaButtonProps extends MarginProps {
  /** Optional callback when user clicks the link. Use only for additional analytics or mutations */
  onClick?: () => void;
  /** Optional analytics name to use instead of the default one */
  analyticsName?: string;
}

/**
 * Button to display a CTA to schedule a virtual walkthrough
 *
 * Should only be shown if:
 * 1. Offer is not expired
 * 2. VA has not been completed
 * 3. Has not already scheduled an assessment
 * 4. Closing is not in progress
 */
export const ScheduleOrvaButton: React.FC<ScheduleOrvaButtonProps> = ({
  onClick,
  analyticsName,
  ...marginProps
}) => {
  const { offer } = useOfferContext();
  if (offer?.state !== 'Sent' && offer?.state !== 'VAInProgress') {
    return null;
  }
  if (offer.isExpired || offer.orvaData.orvaState === ORVAState.ORVA_SCHEDULED) {
    return null;
  }

  return (
    <Box {...marginProps}>
      <InternalLink
        to={getHubORVAScheduleRoute()}
        onClick={onClick}
        variant="primary-button"
        analyticsName={analyticsName || 'cake-schedule-virtual-walkthrough'}
        aria-label={null}
        title="Set up video walkthrough"
        height="56px"
        minW="252px"
      >
        Set up video walkthrough
      </InternalLink>
    </Box>
  );
};
